import { useEffect, useState } from 'react';

import api from '@atom/utilities/api';
import { subdomain, TENANT_ENDPOINT } from '@atom/utilities/endpoints';

export type TenantConnection = {
  type: string;
  name: string;
};

export const useTenantConnections = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [connections, setConnections] = useState<TenantConnection[]>([]);

  useEffect(() => {
    const getTenant = async () => {
      if (!subdomain || subdomain === 'www') {
        return;
      }

      setIsLoading(true);

      try {
        const { data: tenant } = await api.get(
          `${TENANT_ENDPOINT}/${subdomain}`,
        );

        setConnections(tenant?.preferences?.authentication?.connections ?? []);
      } catch {
        // Keep last known connections on error
      } finally {
        setIsLoading(false);
      }
    };

    getTenant();
  }, []);

  return { connections, isLoading };
};
